import { render } from "./EmailLogin.vue?vue&type=template&id=9204bd08"
import script from "./EmailLogin.vue?vue&type=script&lang=js"
export * from "./EmailLogin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__